<template>
    <v-img
      v-if="imageUrl"
      :src="imageUrl"
      aspect-ratio="1"
      max-height="100"
      max-width="200"
    />
  </template>
  
  <script>
  export default {
    name: "ImageBox",
    props: {
        imageUrl: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  